/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

/** @see backend/nexus/modules/Billing/Enum/StripeFeature.php */
export const stripeFeature = {
	'jobilla-meet': 'jobilla-meet',
	'fully-serviced': 'fully-serviced',
	'addon-ats-integration': 'addon-ats-integration',
	'addon-custom-templates': 'addon-custom-templates',
	'addon-custom-invoicing-config': 'addon-custom-invoicing-config',
	'addon-whatsapp': 'addon-whatsapp',
} as const

/** @see backend/nexus/modules/Billing/Enum/StripeFeature.php */
export type StripeFeature = (typeof stripeFeature)[keyof typeof stripeFeature]
